import { LinkTargetTypeType } from "@/types/graphql/partner.generated";

/**
 * Options of the link target picker (links and menu items). Video, stream and
 * collection are one targetType CONTENT, the picker filters the list by
 * ContentType.
 */
export type LinkTargetOption =
  | "PAGE"
  | "POST"
  | "TAG"
  | "VIDEO"
  | "STREAM"
  | "COLLECTION"
  | "PRODUCT";

const SIMPLE_OPTIONS: Partial<Record<LinkTargetTypeType, LinkTargetOption>> = {
  [LinkTargetTypeType.PageType]: "PAGE",
  [LinkTargetTypeType.PostType]: "POST",
  [LinkTargetTypeType.TagType]: "TAG",
  [LinkTargetTypeType.ProductType]: "PRODUCT",
};

// Content path on the storefront: /video/<id>, /stream/<id>, /collection/<id>
// (backend buildContentPath).
const CONTENT_PATH_OPTIONS: Record<string, LinkTargetOption> = {
  video: "VIDEO",
  stream: "STREAM",
  collection: "COLLECTION",
};

function firstPathSegment(url: string): string | undefined {
  try {
    return new URL(url, "http://localhost").pathname.split("/")[1];
  } catch {
    return undefined;
  }
}

/**
 * Picker option of a saved target. For CONTENT the kind comes from the target
 * URL (the API does not return the content type of a link target).
 */
export function resolveLinkTargetOption(
  targetType: LinkTargetTypeType | null | undefined,
  targetUrl: string | null | undefined
): LinkTargetOption | undefined {
  if (!targetType) return undefined;
  if (targetType !== LinkTargetTypeType.ContentType) {
    return SIMPLE_OPTIONS[targetType];
  }
  const segment = targetUrl ? firstPathSegment(targetUrl) : undefined;
  return segment ? CONTENT_PATH_OPTIONS[segment] : undefined;
}

/** Target fields of a form for the API input: only the pair, or null. */
export function linkTargetInput(
  values: { targetType?: LinkTargetTypeType | null; targetId?: string | null },
  internal: boolean
): { targetType: LinkTargetTypeType | null; targetId: string | null } {
  if (!internal || !values.targetType || !values.targetId) {
    return { targetType: null, targetId: null };
  }
  return { targetType: values.targetType, targetId: values.targetId };
}
